import React, { useEffect, useState } from 'react';
import "./editUser.scss";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import GenericForm, { FormField } from '../../../components/GenericForm';
import { updateUser } from '../../../common/api/apiCalls';
import { useQuery } from '@tanstack/react-query';
import { useAlert } from '../../../common/contexts/AlertContext';
import { getAllSites } from '../../../common/api/siteService';
import Loader from '../../../components/Loader/Loader';

const EditUser = () => {
    const location = useLocation();
    const user = location.state?.user;  // Access the user data from state
    console.log('user:', user)
    const { t } = useTranslation();
    const navigate = useNavigate();
    const alert = useAlert();

    const { isLoading, error, data } = useQuery({
        queryKey: ['centerData'],
        queryFn: getAllSites
    });

    // Define the form fields and set initial values based on the user data
    let initialFields: FormField[] = [
      {
        label: "First Name*",
        name: "firstName",
        type: "text",
        initialValue: user?.firstName || "",
      },
      {
        label: "Last Name*",
        name: "lastName",
        type: "text",
        initialValue: user?.lastName || "",
      },
      {
        label: "Email*",
        name: "email",
        type: "email",
        initialValue: user?.email || "",
      },
      {
        label: "ID Number*",
        name: "idNumber",
        type: "text",
        initialValue: user?.identityNumber || "",
      },
      {
        label: "Role*",
        name: "role",
        type: "select",
        options: [
          { label: "Admin", value: "Admin" },
          { label: "HCP", value: "HCP" },
        ],
        initialValue: user?.role,
      },
      {
        label: "Center",
        name: "center",
        type: "select",
        options: [],
        initialValue: user?.center,
      },
      {
        // label: "User Status",
        label: "Active / Inactive",
        name: "status",
        type: "switch",
        initialValue: user?.status === "Active" ? true : false,
      },
    ];
    const [fields, setFields] = useState<FormField[]>(initialFields);

    const getText = (text: string) => t(`CreateUser.${text}`);

    const handleSubmit = async (formData: { [key: string]: any }) => {
        console.log('Form submitted with data:', formData);
        const userAccountStatus = formData.status ? "Active" : "Inactive";
        const res = await updateUser({
            username: formData.email,
            firstName: formData.firstName,
            lastName: formData.lastName,
            identityNumber: formData.idNumber,
            role: formData.role,
            site: formData.center,
            phoneNumber: formData.phoneNumber,
            status: userAccountStatus,
        });

        if (res.success) {
            alert("Success", "msg");
            navigate(-1)
        } else {
            alert("Fail", "error");
        }
    };

    useEffect(() => {
        if (Array.isArray(data)) {
            const updatedFields = fields.map(field => {
                if (field.name === 'center') {
                    return {
                        ...field,
                        options: data
                            .filter((site: any) => site && site.SiteName) // Ensure site and SiteName exist
                            .map((site: any) => ({ label: site.SiteName, value: site.SiteName }))
                    };
                }
                return field;
            });
            setFields(updatedFields);
        }
    }, [data]);

    if (isLoading) {
        return <Loader text="Loading..." />;
    }

    if (error) {
        return <div>{getText("Error fetching centers")}</div>;
    }

    return (
        <>
            <GenericForm
                backButtonAction={() => navigate(-1)}
                backButtonText={getText("Back")}
                buttonText={getText("Save_changes")}
                fields={fields}
                onSubmit={handleSubmit}
                title={getText("edit_user")}
            />
        </>
    );
};

export default EditUser;
